import { IconCardProps } from 'components';

export interface BenefitAction extends IconCardProps {
  id: string;
  policyYear?: string;
  yeartitle?: string;
}

export const enum OUTPATIENT_TYPES {
  COVERAGE = 'coverage',
  USAGE = 'usage',
}

// Note(Andy Chow): Will be moving these keys to another global file
export const enum SWR_KEY {
  POLICY_INFO = 'PolicyInfo',
  BENEFIT_USAGE = 'BenefitUsage',
  DOCUMENTS = 'Documents',
  BENEFIT_CLAIM_TYPE = 'BenefitClaimType',
  HAS_SURGERY_CLASSIFICATION = 'HasSurveyClassification',
}
export interface SelectionName {
  id: string;
  label: string;
  memberId: string;
  memberType: string;
  firstName: string;
  lastName: string;
}

export interface SelectionPeriod {
  id: string;
  startDate: string;
  endDate: string;
}
